import React, { useEffect } from 'react';
import {
  Outlet,
  useNavigate
} from "react-router-dom";
import {
  useSelector,
  useDispatch
} from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';

import { logoutUser, getProfile } from '../../store/actions';
import { setNavigate } from '../../utils/navigator';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
  },
}));

const SimpleLayout = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  setNavigate(navigate);

  const { authEvent, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (authEvent === 'logout') {
      navigate('/login');
    } else if (!user.accountName) {
      dispatch(getProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authEvent]);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" className={classes.title} noWrap>
            Asset Docket
          </Typography>
          <Button color="inherit" variant="outlined" onClick={handleLogout}>Logout</Button>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Outlet />
      </main>
    </div>
  );
};

export { SimpleLayout };
